 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-01347eea":"0801eb27","chunk-0232e452":"621a5a30","chunk-1ca8281b":"969cd8a2","chunk-2d2172bd":"503d9680","chunk-a392f8e0":"56e365cd","chunk-2fefc2ba":"d6504cf9","chunk-375c8d73":"c22b9dd7","chunk-af066220":"0e5db218","chunk-68610262":"3ff41023","chunk-2cb63e3a":"b7abc167","chunk-1eb87d8c":"34769824","chunk-29bebfab":"5e1bd440","chunk-2d0a3159":"3cc830e3","chunk-2d0dd7af":"ea3dcbd1","chunk-2d0ddba1":"4a331284","chunk-2d20864f":"72d7cf39","chunk-2d22b970":"1aaf7aac","chunk-2d21a841":"3e69ee57","chunk-2d237ffc":"8b7723fb","chunk-52e61669":"eaa7f538","chunk-4442e952":"bf7ec80e","chunk-48239905":"75d3aeff","chunk-4e69cf76":"914643dd","chunk-50d21eb3":"f9736f2d","chunk-57cc81a2":"1ebae965","chunk-5c4c15db":"0dec387e","chunk-00978fa7":"850a510d","chunk-df2ead5c":"7fbaa38f","chunk-6b29dd13":"1b1ea6eb","chunk-2d0aa281":"0d842714","chunk-2d0ae5d6":"71a1878a","chunk-2d0da355":"b04bd663","chunk-2d216ba8":"b6159c15","chunk-6bbebb1d":"f9ec95a5","chunk-b57fc804":"cd1a4f53","chunk-5d6a9ac0":"0403c46a","chunk-62f7dd98":"cbd2f259","chunk-68d1576d":"8e0ba0a8","chunk-691e8e62":"76e2b162","chunk-222a1108":"ed93fd58","chunk-69505e62":"e744950e","chunk-4319630e":"43752c05","chunk-577c862a":"455d514c","chunk-d4a1374e":"288195a5","chunk-12b08fbe":"04f0a91b","chunk-17829288":"667ec19a","chunk-46cbb527":"adad0c40","chunk-56e47990":"701de5d5","chunk-3d494bb4":"2d7ba8b4","chunk-1609a910":"69675d7c","chunk-2751310e":"1d8df2de","chunk-2d22693c":"b52dd7fb","chunk-1cdb75a5":"8fc5fa3d","chunk-513d0d46":"e2fe38ff","chunk-d5be2126":"0d465b47","chunk-2d22d3f4":"7a5cfb55","chunk-d5adab10":"96f5f6c5","chunk-889f54bc":"bf827d9a","chunk-a9632ad4":"738b2f9b","chunk-ddbd689a":"0c488f5e","chunk-2f65855c":"aa7dbe58","chunk-ecae29fc":"e30eac3a","chunk-f8432fd6":"713c1c99","chunk-10d582ee":"1fc04cf2","chunk-1d94d3f1":"bba3c0c9","chunk-2d0cc2ee":"dd52f2d8","chunk-3e2e8798":"0d3750f7","chunk-401d5cd2":"34a0eb9d","chunk-2cf0b788":"707c7e15","chunk-e0125934":"c6d96896","chunk-cc8c7e28":"190e1ff8","chunk-743c2ddb":"a76340f5","chunk-7457c560":"de003d3e","chunk-745a3122":"a496ad2d","chunk-7467d5b8":"81acc37a","chunk-7482e5bc":"a45e4312","chunk-74af77ea":"72d835d8","chunk-74b7681c":"af3b4519","chunk-74bb0962":"1d1c34d4","chunk-76f042f8":"cf4c94f3","chunk-774c8cf7":"d2e748d9","chunk-2d2223ef":"505e0ccd","chunk-2d607d30":"3483c2c4","chunk-2f83f030":"9f01d274","chunk-4aad5e3d":"4fdf9b55","chunk-62fe80ef":"adb5b3be","chunk-71fa889d":"8f130651","chunk-7d47e309":"4b9d8ba1","chunk-28f7a0c7":"bebcdc8a","chunk-ad1740b0":"c982046c","chunk-17a63ea5":"eff63b1d","chunk-2d209b31":"54072f58","chunk-0987dada":"02eb9708","chunk-6943e552":"58215185","chunk-80018e16":"8545b345","chunk-a1825bbc":"b073712f","chunk-55693694":"8bdbd52e","chunk-3cfb2b44":"a08cbbcc","chunk-867de25a":"30f8dfe0","chunk-ba57138a":"2f5d48f4","chunk-f210cb80":"c48ead6b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01347eea":1,"chunk-0232e452":1,"chunk-1ca8281b":1,"chunk-a392f8e0":1,"chunk-2fefc2ba":1,"chunk-375c8d73":1,"chunk-af066220":1,"chunk-68610262":1,"chunk-2cb63e3a":1,"chunk-1eb87d8c":1,"chunk-29bebfab":1,"chunk-52e61669":1,"chunk-4442e952":1,"chunk-48239905":1,"chunk-4e69cf76":1,"chunk-50d21eb3":1,"chunk-57cc81a2":1,"chunk-5c4c15db":1,"chunk-6b29dd13":1,"chunk-6bbebb1d":1,"chunk-5d6a9ac0":1,"chunk-62f7dd98":1,"chunk-68d1576d":1,"chunk-691e8e62":1,"chunk-222a1108":1,"chunk-69505e62":1,"chunk-4319630e":1,"chunk-577c862a":1,"chunk-d4a1374e":1,"chunk-12b08fbe":1,"chunk-17829288":1,"chunk-46cbb527":1,"chunk-56e47990":1,"chunk-3d494bb4":1,"chunk-1609a910":1,"chunk-2751310e":1,"chunk-1cdb75a5":1,"chunk-513d0d46":1,"chunk-d5be2126":1,"chunk-d5adab10":1,"chunk-889f54bc":1,"chunk-a9632ad4":1,"chunk-ddbd689a":1,"chunk-2f65855c":1,"chunk-ecae29fc":1,"chunk-f8432fd6":1,"chunk-10d582ee":1,"chunk-1d94d3f1":1,"chunk-401d5cd2":1,"chunk-2cf0b788":1,"chunk-e0125934":1,"chunk-cc8c7e28":1,"chunk-743c2ddb":1,"chunk-7457c560":1,"chunk-745a3122":1,"chunk-7467d5b8":1,"chunk-7482e5bc":1,"chunk-74af77ea":1,"chunk-74b7681c":1,"chunk-74bb0962":1,"chunk-76f042f8":1,"chunk-774c8cf7":1,"chunk-2d607d30":1,"chunk-2f83f030":1,"chunk-4aad5e3d":1,"chunk-62fe80ef":1,"chunk-71fa889d":1,"chunk-28f7a0c7":1,"chunk-ad1740b0":1,"chunk-17a63ea5":1,"chunk-0987dada":1,"chunk-6943e552":1,"chunk-80018e16":1,"chunk-a1825bbc":1,"chunk-55693694":1,"chunk-3cfb2b44":1,"chunk-867de25a":1,"chunk-ba57138a":1,"chunk-f210cb80":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-01347eea":"1eddce2c","chunk-0232e452":"e4bde69a","chunk-1ca8281b":"0bb5e88d","chunk-2d2172bd":"31d6cfe0","chunk-a392f8e0":"6d6dbb4c","chunk-2fefc2ba":"3b1cc4df","chunk-375c8d73":"4f501797","chunk-af066220":"7bc1cae6","chunk-68610262":"81cee1a6","chunk-2cb63e3a":"7de0dee6","chunk-1eb87d8c":"6ad24d94","chunk-29bebfab":"ef0da253","chunk-2d0a3159":"31d6cfe0","chunk-2d0dd7af":"31d6cfe0","chunk-2d0ddba1":"31d6cfe0","chunk-2d20864f":"31d6cfe0","chunk-2d22b970":"31d6cfe0","chunk-2d21a841":"31d6cfe0","chunk-2d237ffc":"31d6cfe0","chunk-52e61669":"3bf05275","chunk-4442e952":"04ea624b","chunk-48239905":"99672fc4","chunk-4e69cf76":"097b5913","chunk-50d21eb3":"9f69edb5","chunk-57cc81a2":"37df1425","chunk-5c4c15db":"832f84b9","chunk-00978fa7":"31d6cfe0","chunk-df2ead5c":"31d6cfe0","chunk-6b29dd13":"308b3bd8","chunk-2d0aa281":"31d6cfe0","chunk-2d0ae5d6":"31d6cfe0","chunk-2d0da355":"31d6cfe0","chunk-2d216ba8":"31d6cfe0","chunk-6bbebb1d":"bf084e40","chunk-b57fc804":"31d6cfe0","chunk-5d6a9ac0":"164ebb96","chunk-62f7dd98":"3e025a0f","chunk-68d1576d":"72998b90","chunk-691e8e62":"2e47df85","chunk-222a1108":"56fe509a","chunk-69505e62":"96e01ab6","chunk-4319630e":"15b9cb31","chunk-577c862a":"e180a1be","chunk-d4a1374e":"a136cfdd","chunk-12b08fbe":"99744b51","chunk-17829288":"a1a24b77","chunk-46cbb527":"88219f6f","chunk-56e47990":"fce8b943","chunk-3d494bb4":"6c22b62d","chunk-1609a910":"5803102e","chunk-2751310e":"7e1ecbad","chunk-2d22693c":"31d6cfe0","chunk-1cdb75a5":"4dca7338","chunk-513d0d46":"089cc77e","chunk-d5be2126":"77bfc3a9","chunk-2d22d3f4":"31d6cfe0","chunk-d5adab10":"862a75ad","chunk-889f54bc":"e1d0fec9","chunk-a9632ad4":"ddb6d2a6","chunk-ddbd689a":"5c5d407e","chunk-2f65855c":"017c0bbc","chunk-ecae29fc":"2457469d","chunk-f8432fd6":"2457469d","chunk-10d582ee":"91868441","chunk-1d94d3f1":"a140772d","chunk-2d0cc2ee":"31d6cfe0","chunk-3e2e8798":"31d6cfe0","chunk-401d5cd2":"6cb98cce","chunk-2cf0b788":"a97febbf","chunk-e0125934":"367bb202","chunk-cc8c7e28":"18de71cc","chunk-743c2ddb":"0dd2478f","chunk-7457c560":"d4ad834b","chunk-745a3122":"d7dc1639","chunk-7467d5b8":"97906909","chunk-7482e5bc":"3fc962f4","chunk-74af77ea":"23b17eb2","chunk-74b7681c":"6ff76692","chunk-74bb0962":"06c127ee","chunk-76f042f8":"a3d504dc","chunk-774c8cf7":"93e9293c","chunk-2d2223ef":"31d6cfe0","chunk-2d607d30":"d09cf3eb","chunk-2f83f030":"f2e3d023","chunk-4aad5e3d":"2405960a","chunk-62fe80ef":"c0261f0b","chunk-71fa889d":"07cc3c21","chunk-7d47e309":"31d6cfe0","chunk-28f7a0c7":"4c6ce4a0","chunk-ad1740b0":"18f5736b","chunk-17a63ea5":"0da95f5b","chunk-2d209b31":"31d6cfe0","chunk-0987dada":"db5d03c5","chunk-6943e552":"b196006c","chunk-80018e16":"8bc269ef","chunk-a1825bbc":"c22f5ac1","chunk-55693694":"2e1a912a","chunk-3cfb2b44":"5f487c00","chunk-867de25a":"36a04839","chunk-ba57138a":"c62c4385","chunk-f210cb80":"5da84a9f"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://presenter.ahaslides.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
